import React from "react";
import "../../css/model.css";
import { formatDate } from "../../utils/formatDate";

const RegulatoryInsightCard = ({ insight }) => {
  if (!insight) return null;

  const { title, content, badge, badgeColor, sourceLabel, sourceUrl, publishedAt } = insight;

  const getBadgeStyle = (color) => {
    const styles = {
      red: {
        background: "rgba(239, 68, 68, 0.15)",
        color: "#ef4444",
      },
      yellow: {
        background: "rgba(234, 179, 8, 0.15)",
        color: "#eab308",
      },
      green: {
        background: "rgba(34, 197, 94, 0.15)",
        color: "#22c55e",
      },
    };
    return styles[color] || styles.red;
  };

  const badgeStyle = getBadgeStyle(badgeColor);
  const formattedDate = formatDate(publishedAt);

  return (
    <div className="regulatory-insight-card">
      <div className="regulatory-insight-card__body">
        <h3 className="regulatory-insight-card__title">
          {title}
        </h3>

        <p className="regulatory-insight-card__content">
          {content}
        </p>

        <div className="regulatory-insight-card__footer">
          {badge && (
            <span className="regulatory-insight-card__badge" style={badgeStyle}>
              {badge}
            </span>
          )}
          {formattedDate && (
            <span className="regulatory-insight-card__date">{formattedDate}</span>
          )}
          {(sourceLabel || sourceUrl) && (
            sourceUrl ? (
              <a
                href={sourceUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="regulatory-insight-card__source"
              >
                {sourceLabel || sourceUrl}
              </a>
            ) : (
              <span className="regulatory-insight-card__source">{sourceLabel}</span>
            )
          )}
        </div>
      </div>
    </div>
  );
};

export default RegulatoryInsightCard;
